import React from 'react';
import { MdSchool, MdCalendarToday, MdArrowForward } from 'react-icons/md';

const PublicClassesSection = ({ classes, loading, error }) => {
  const handleClassClick = (classId) => {
    window.location.href = `/public/classes/${classId}`;
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20">
        <div className="animate-spin rounded-full h-10 w-10 border-2 border-blue-600 border-t-transparent"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
        <p className="text-red-700 text-sm">{error}</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl border border-gray-200">
      {classes.length === 0 ? (
        <div className="text-center py-20">
          <div className="mx-auto w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mb-4">
            <MdSchool className="text-gray-400 text-xl" />
          </div>
          <h3 className="text-lg font-medium text-gray-900 mb-2">No public courses available</h3>
          <p className="text-gray-500 text-sm">
            Check back later for public course offerings.
          </p>
        </div>
      ) : (
        <div className="divide-y divide-gray-200">
          {classes.map((cls) => (
            <button
              key={cls.class_id}
              onClick={() => handleClassClick(cls.class_id)}
              className="w-full px-6 py-4 hover:bg-gray-50 transition-colors text-left group"
            >
              <div className="flex items-center justify-between">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-3 mb-2">
                    <h3 className="font-semibold text-gray-900 text-lg">
                      {cls.class_name || 'Unknown Class'}
                    </h3>
                    <span className="text-sm text-gray-500">
                      {cls.class_code || 'N/A'}
                    </span>
                  </div>
                  <div className="flex items-center gap-4 text-sm text-gray-600">
                    <div className="flex items-center gap-1">
                      <MdCalendarToday className="text-gray-400" />
                      <span>{cls.semester || 'N/A'} {cls.year || 'N/A'}</span>
                    </div>
                    {cls.description && (
                      <span className="text-gray-500 truncate max-w-md">
                        {cls.description}
                      </span>
                    )}
                  </div>
                </div>
                <MdArrowForward className="text-gray-400 group-hover:text-blue-600 transition-colors flex-shrink-0 ml-4" />
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default PublicClassesSection;

